import { Button } from 'primereact/button';
import classNames from 'classnames';
import { Tooltip } from 'primereact/tooltip';
import dayjs from 'dayjs';
import { InputSwitch } from 'primereact/inputswitch';

import { ColumnDescription } from '@/components/common/ui/table/ColumnDescription';

export const MentorColumns = (
  t: any,
  onEditMentor?: (id: number) => void,
  onEditStatusMentor?: (isActive: boolean, rowData: any) => void,
): ColumnDescription[] => [
  {
    dataField: 'full_name_kanji',
    text: t('user_list.full_name_mentor'),
    classname: 'min-w-[104px]',
    formatter: (rowData: any) => {
      return (
        <div>
          <Tooltip target={`.tooltip-name-${rowData.id}`}>
            {rowData.full_name_kanji}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-900 break-all w-fit',
              `tooltip-name-${rowData.id}`,
            )}
            data-pr-position="top"
          >
            {rowData.full_name_kanji}
          </div>
        </div>
      );
    },
  },
  {
    dataField: 'email',
    text: t('user_list.email'),
    classname: 'min-w-[154px]',
    formatter: (rowData: any) => {
      return (
        <div>
          <Tooltip target={`.tooltip-email-${rowData.id}`}>
            {rowData.email}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-900 break-all w-fit',
              `tooltip-email-${rowData.id}`,
            )}
            data-pr-position="top"
          >
            {rowData.email}
          </div>
        </div>
      );
    },
  },
  {
    dataField: 'created_at',
    text: t('user_list.created_at_mentor'),
    classname: 'w-[200px]',
    sort: true,
    formatter: (rowData) => (
      <div>
        {rowData.created_at
          ? dayjs(rowData.created_at.toString()).format('YYYY/MM/DD')
          : ''}
      </div>
    ),
  },
  {
    dataField: 'action',
    text: '',
    sort: false,
    classname: 'text-center [&>div]:justify-center w-[160px]',
    headerClassname: '[&>div]:justify-center',
    formatter: (rowData) => (
      <div className="flex flex-row h-[36px] items-center">
        <InputSwitch
          checked={rowData.status === 'active' ? true : false}
          onChange={(e) => onEditStatusMentor?.(e.value, rowData)}
        />
        <Button
          className="mx-3 p-[10px]"
          onClick={() => onEditMentor?.(rowData.id)}
        >
          <span className="pi pi-pencil" />
        </Button>
      </div>
    ),
  },
];
